import { Command } from 'commands/Commands';

export class SetOrder extends Command {
  type: string = 'Award.SetOrder';
  priority = 150;
}
